<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.currency.dialog.title' | translate"
		id="currency-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<ins-checkbox
							id="currency-dialog-default"
							[(ngModel)]="viewModel.bo.model.default"
							[label]="'scenes.configuration.shared.currency.dialog.form.default.label' | translate"
							[sklValidate]="getValidationKey('default')">
						</ins-checkbox>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.currency.dialog.form.symbol.label' | translate">
							<ins-input
								id="currency-dialog-symbol"
								[skl-focus-by]
								[(ngModel)]="viewModel.bo.model.symbol"
								[placeholder]="'scenes.configuration.shared.currency.dialog.form.symbol.placeholder' | translate"
								[sklValidate]="getValidationKey('symbol')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.currency.dialog.form.name.label' | translate">
							<ins-input
								id="currency-dialog-name"
								[(ngModel)]="viewModel.bo.model.name"
								[placeholder]="'scenes.configuration.shared.currency.dialog.form.name.placeholder' | translate"
								[sklValidate]="getValidationKey('name')">
							</ins-input>
						</ins-form-field>
					</div>
					<div class="col-1">
						<ins-form-field
							[label]="'scenes.configuration.shared.currency.dialog.form.precision.label' | translate">
							<ins-input
								id="currency-dialog-precision"
								rtl="false"
								inputmode="decimal"
								[(ngModel)]="viewModel.bo.model.precision"
								[precision]="0"
								[placeholder]="'scenes.configuration.shared.currency.dialog.form.precision.placeholder' | translate"
								[sklValidate]="getValidationKey('precision')">
							</ins-input>
						</ins-form-field>
					</div>
				</div>
			}
		</skl-form-container>

	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="currency-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="currency-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>
